export default __webpack_public_path__ + "static/media/female_avatar.d37bb340.svg";